// extracted by mini-css-extract-plugin
export default {"titleTransition":"Contact_titleTransition__r9lEV","fadeOut":"Contact_fadeOut__PtHmI","fadeIn":"Contact_fadeIn__MO2rV"};